import { NavigateFunction } from 'react-router-dom';

export function redirection(navigate: NavigateFunction, lien: string) {
    navigate(lien);
}